import { z } from "zod";
import {
  baseProductSchema,
  defaultBaseProductValues,
} from "./base-product.schema";

export const updateProductSchema = baseProductSchema;

export type UpdateProductForm = z.infer<typeof updateProductSchema>;

export const defaultUpdateProductValues: UpdateProductForm = defaultBaseProductValues;
